import { render, staticRenderFns } from "./FilterOption.vue?vue&type=template&id=2123a47b&scoped=true&"
import script from "./FilterOption.vue?vue&type=script&lang=js&"
export * from "./FilterOption.vue?vue&type=script&lang=js&"
import style0 from "./FilterOption.vue?vue&type=style&index=0&id=2123a47b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123a47b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
